/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { BaseApiService } from './BaseApiService';
import type { HotelDealsRequest, OuterHotelDealsAPIResponse } from '../types';
import type { AppEnvironment } from '../types';

export class HotelsRecommendationService extends BaseApiService {
  constructor(environment: AppEnvironment = 'stg') {
    super(environment, {
      stg: 'https://recommend.stg-apiairasia.com',
      prd: 'https://recommend.apiairasia.com',
    });
  }

  public getHotelDeals(
    request: HotelDealsRequest,
  ): Promise<OuterHotelDealsAPIResponse> {
    return this.post('/v3/recommendations/', {
      userId: request.userId,
      locale: request.locale,
      lob: ['HOTEL'],
      location: {
        country: request.location.country,
        nearestAirport: request.location.nearestAirport,
      },
      currency: request.currency,
      cardCount: request.cardCount,
      debug: request.debug,
      targetingCodes: request.targetingCodes,
    });
  }
}
